import React from 'react';
import { ProductSpecs as ProductSpecsType } from '../../types';
import { useTranslation } from '../../lib/i18n';
interface ProductSpecsProps {
  specs: ProductSpecsType;
}
export function ProductSpecs({
  specs
}: ProductSpecsProps) {
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  const ru = lang === 'ru';
  const specItems = [{
    label: en ? 'Capacity' : ru ? 'Грузоподъёмность' : 'Kapacitet',
    value: specs.capacity
  }, {
    label: en ? 'Motor' : ru ? 'Мотор' : 'Motor',
    value: specs.motor
  }, {
    label: en ? 'Battery' : ru ? 'Аккумулятор' : 'Baterija',
    value: en && specs.batteryEn ? specs.batteryEn : ru && specs.batteryRu ? specs.batteryRu : specs.battery
  }, {
    label: en ? 'Charging time' : ru ? 'Время зарядки' : 'Vreme punjenja',
    value: specs.chargingTime
  }, {
    label: en ? 'Climbing speed' : ru ? 'Скорость подъёма' : 'Brzina penjanja',
    value: en && specs.climbingSpeedEn ? specs.climbingSpeedEn : ru && specs.climbingSpeedRu ? specs.climbingSpeedRu : specs.climbingSpeed
  }, {
    label: en ? 'Dimensions' : ru ? 'Размеры' : 'Dimenzije',
    value: specs.size
  }, {
    label: en ? 'Folding thickness' : ru ? 'Толщина в сложенном виде' : 'Debljina sklopljeno',
    value: specs.foldingThickness
  }, {
    label: en ? 'Weight' : ru ? 'Вес' : 'Težina',
    value: specs.weight
  }, {
    label: en ? 'Lead time' : ru ? 'Срок поставки' : 'Rok isporuke',
    value: en && specs.leadTimeEn ? specs.leadTimeEn : ru && specs.leadTimeRu ? specs.leadTimeRu : specs.leadTime
  }];
  return <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-559" data-mp="1bzkauywnxjfc">
      {specItems.map(item => <div key={item.label} className="bg-dark-surface border-2 border-dark-border rounded-industrial p-4" data-id="element-560" data-mp="3em8y2iig5ipx">
          <dt className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-1" data-id="element-561" data-mp="39uhewt1mef9t">
            {item.label}
          </dt>
          <dd className="text-lg font-bold text-white" data-id="element-562" data-mp="34wpgdg6gzuwn">{item.value}</dd>
        </div>)}
    </div>;
}